<template>
    <footer>
        <p>
            <a href="https://www.wer-gewinnt-die-wahl.de" class="main-link">www.wer-gewinnt-die-wahl.de</a>
        </p>        
        <p class="footer-nav">
            <a href="https://www.inwt-statistics.de" target="_blank">INWT Statistics GmbH</a> |
            <router-link :to="'/' + $i18n.locale + '/imprint'">{{ $t('other_imprint') }}</router-link> | 
            <router-link  :to="'/' + $i18n.locale + '/dataprotection'">{{ $t('other_data_protection') }}</router-link> | 
            <a :href="$t('twitter_url')" name="Twitter" target="_blank">Twitter</a> |
            <a href="https://github.com/INWTlab/lsTerm-election-forecast" name="GitHub" target="_blank">{{ $t('other_github') }}</a>
        </p>
        <p class="inwt-link">
            <a href="https://www.inwt-statistics.de" target="_blank" class="plain">
                <img src="/logo.svg" height="100" alt="INWT Statistics GmbH">
            </a>
        </p>
        <p class="language-switcher">
            <a @click="reloadLocale('de')" class="plain" :class="{active: $i18n.locale == 'de'}">Deutsch</a> |
            <a @click="reloadLocale('en')" class="plain" :class="{active: $i18n.locale == 'en'}">English</a>
        </p>
    </footer>
</template>

<script>
export default {
    methods: {
        reloadLocale (locale) {
            let getUrl = window.location;
            location.href = getUrl .protocol + "//" + getUrl.host + "/" + locale + "/" + getUrl.pathname.split('/').slice(2).join('/');
        }
    }
}
</script>

<style scoped>
  a.main-link {
      font-weight: 800;
      font-style: italic;
      font-size: 1.25rem;
      color: var(--black-primary);
  }
  
  .inwt-link {
      margin: 1.5em;
  }

  .footer-nav a {
     font-weight: 400;
     color: var(--black-primary);
  }

  .language-switcher a {
      color: var(--black-primary);
  }

  .language-switcher a.active {
      border-bottom: 1px var(--black-primary) solid;
  }
</style>